import type {
  Content,
  ContentBlockTag,
  Part,
  PartVideo,
  PrintingToolConfigurationType,
  SmartGuideType,
  StandardTag,
  StepType,
} from '@innovamat/smart-guides';

function prepareSmartGuideForPrinting(
  preprResource: SmartGuideType,
  configuration: PrintingToolConfigurationType
): SmartGuideType {
  return {
    ...preprResource,
    summary: {
      ...preprResource?.summary,
      assessables: configuration.commonAttributes.includes('assessment')
        ? preprResource?.summary?.assessables
        : [],
      dimensionTags: configuration.commonAttributes.includes('dimensions')
        ? preprResource?.summary?.dimensionTags
        : [],
      materials: configuration.commonAttributes.includes('materials')
        ? preprResource?.summary?.materials
        : {},
      bigIdeas: configuration.blockOptions.includes('bigIdeas')
        ? preprResource?.summary?.bigIdeas
        : [],
      newMathPractices: configuration.blockOptions.includes('smp')
        ? preprResource?.summary?.newMathPractices
        : [],
      newStandardContent: (() => {
        const smcSelected = configuration.blockOptions.includes('smc');
        const contentBlocksSelected =
          configuration.blockOptions.includes('contentBlocks');

        if (!smcSelected && !contentBlocksSelected) {
          return [];
        }

        const allContent = preprResource?.summary?.newStandardContent || [];

        if (smcSelected && contentBlocksSelected) {
          return allContent;
        }

        if (smcSelected) {
          return allContent.filter((standard): standard is StandardTag => {
            return 'tooltipKey' in standard;
          });
        }

        return allContent.filter((standard): standard is ContentBlockTag => {
          return !('tooltipKey' in standard);
        });
      })(),
    },
    parts: preprResource?.parts.map((part: Part & PartVideo) => ({
      ...part,
      steps: part.steps
        ?.filter(
          (step: StepType) =>
            (configuration.acceptedTypes.commonTips.includes(step.__typename) &&
              configuration.commonTips.includes(step.__typename)) ||
            !configuration.acceptedTypes.commonTips.includes(step.__typename)
        )
        .map((step: StepType) => ({
          ...step,
          ...(step.__typename === 'PasoNumerado' &&
            step.content && {
              content: step.content.filter(
                (content: Content) =>
                  (content.__typename === 'Signedtip' &&
                    configuration.signedTips.includes(content.tip_type)) ||
                  (configuration.acceptedTypes.commonTips.includes(
                    content.__typename
                  ) &&
                    configuration.commonTips.includes(content.__typename)) ||
                  (!configuration.acceptedTypes.commonTips.includes(
                    content.__typename
                  ) &&
                    content.__typename !== 'Signedtip')
              ),
            }),
        })),
    })),
  };
}

export { prepareSmartGuideForPrinting };
